import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "favourites-on",
  "use": "favourites-on-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"favourites-on\"><path d=\"M16.428 23.397s-8.5-4.773-8.5-10.568a4.44 4.44 0 0 1 1.002-2.81 4.41 4.41 0 0 1 5.496-1.102 4.427 4.427 0 0 1 2.002 2.207 4.428 4.428 0 0 1 2.002-2.207 4.41 4.41 0 0 1 5.496 1.102 4.44 4.44 0 0 1 1.002 2.81c0 5.795-8.5 10.568-8.5 10.568Z\" fill=\"#FFAE8A\" stroke=\"#FFAE8A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol